import {
  ACTION_LOAD_FISCAL_NUMBER__REQUEST,
  ACTION_LOAD_FISCAL_NUMBER__SUCCESS,
  ACTION_LOAD_FISCAL_NUMBER__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_FISCAL_NUMBER__REQUEST:
    case ACTION_LOAD_FISCAL_NUMBER__SUCCESS:
      return null;

    case ACTION_LOAD_FISCAL_NUMBER__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
